import { getParsePaletteColor, palette2, setOpacity, } from '../../../../foundation';
export function getHighlightStyle(_a) {
    var backgroundColorProp = _a.backgroundColorProp, theme = _a.theme;
    var backgroundColor = (backgroundColorProp
        ? getParsePaletteColor(backgroundColorProp)
        : setOpacity(palette2('warning', 'b03'), '12'))({ theme: theme });
    var styles = {
        entering: {
            backgroundColor: backgroundColor,
        },
        entered: {
            backgroundColor: backgroundColor,
        },
        exiting: {
            backgroundColor: 'rgba(255, 255, 255, 0)',
        },
        exited: {
            backgroundColor: '',
        },
    };
    return styles;
}
